export const environment = {
  production: true,
  defaultUrlServer: 'https://invent.programaremedic.ro/api/mds/',
  deployId: 'e9a01abc-2860-4be4-be21-9f59471268ba',
  filePath: 'https://invent.programaremedic.ro/api/mds_file/',
  authServer: 'https://invent.programaremedic.ro/api/auth/',
  saasServer: 'https://invent.programaremedic.ro/api/saas/',
  signalR: 'https://invent.programaremedic.ro/api/saas_hub',
	notifyServer: 'wss://ws-prod.dohu.dev/notify',
};
